import React from 'react';
import Header from '../../components/user-section/CareerPage/Header';
import Main from '../../components/user-section/CareerPage/HeroSection';
import './Career.css'
const Career = () => {
  return (
    <>
      <Header />
      <Main/>
     
    </>
  );
};

export default Career;
